import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractsComponent } from './contracts.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { FormsModule } from '@angular/forms';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { DossierDetailModule } from '../components/dossierDetail.module';
import { DocumentFileModule } from '../../documents/documentFile/documentFile.module';
import { TableModule } from 'primeng-lts/table';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { MainPipes } from '../../pipes/main-pipes-module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { ContractsDemoComponent } from './contractsDemo.component';
import { ContractComponent } from './contract.component';
import { contractModificationTypesComponent } from '../contractModifications/contractModificationTypes.component';
import { DossierActionsListComponent } from '../dossierActions/dossierActionsList.component';
import { DossierActionsModule } from '../dossierActions/dossierActions.module';
import { RejectionPanelComponent } from '../../documents/rejectionPanel/rejectionPanel.component';
import { RejectionPanelModule } from '../../documents/rejectionPanel/rejectionPanel.module';
import { ExecutionDivisionEditionComponent } from './executioDivision.edition.component';
import { ButtonModule } from 'primeng-lts/button';
import { ChartModule } from 'primeng-lts/chart';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputMaskModule } from 'primeng-lts/inputmask';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { FieldsetModule } from 'primeng-lts/fieldset';
import { InplaceModule } from 'primeng-lts/inplace';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { SliderModule } from 'primeng-lts/slider';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { PlanningModule } from '../planning/planning.module';
import { ContractAYMADComponent } from '../../aymad/contracts/contractAYMAD.component';
import { ContractHeaderComponent } from '../../aymad/contracts/contractHeader.component';
import { ContractsAYMADComponent } from '../../aymad/contracts/contractsAYMAD.component';
import { ConfigurationModule } from '../../admin/configuration/configuration.module';
import { configurationComponent } from '../../admin/configuration/configuration.component';
import { InputNumberModule } from 'primeng-lts/inputnumber';
import { PMenuActionsModule } from '../../actions/pmenu.actions.module';

@NgModule({
  declarations: [ContractsComponent, ContractsDemoComponent, ContractComponent, ContractsAYMADComponent, ContractAYMADComponent,
    ExecutionDivisionEditionComponent, ContractHeaderComponent],
  imports: [
    SubHeaderModule,
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,
    DocumentFileModule,

    TableModule,
    TooltipModule,
    ProgressBarModule,
    ToggleButtonModule,
    FormPlycaModule,
    PanelModule,
    TabViewModule,
    CheckboxModule,
    MenuModule,
    OverlayPanelModule,
    SliderModule,
    ChartModule,
    ButtonModule,
    SelectButtonModule,
    InputTextareaModule,
    InputMaskModule,
    MultiSelectModule,
    FieldsetModule,
    DropdownModule,
    TranslateModule,
    InplaceModule,
    MainPipes,
    WaitLoadingModule,
    InputSwitchModule,
    DialogModule,
    DynamicDialogModule,
    ScrollPanelModule,
    DossierActionsModule,
    InplaceModule,
    RejectionPanelModule,
    PlanningModule,
    ConfigurationModule,
    InplaceModule,
    InputNumberModule,
    PMenuActionsModule
  ],
  entryComponents: [
    contractModificationTypesComponent,
    DossierActionsListComponent,
    RejectionPanelComponent,
    ExecutionDivisionEditionComponent,
    configurationComponent
  ],
  exports: [
    ContractHeaderComponent
  ]
})
export class ContractsModule { }
